// @flow

import * as React from 'react';
import {useState} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Button} from 'sail/Button';
import Group from 'sail/Group';
import {chevronDown, chevronUp} from 'sail/Icon/Assets';

const messages = defineMessages({
  viewDetails: {
    id: 'docsApp.components.expandableDetailsButton.viewDetails',
    description: 'Label on the expand details button.',
    defaultMessage: 'View details',
  },
});

type ExpandableDetailsButtonProps = {|
  children?: React.Node,
|};

export const ExpandableDetailsButton = ({
  children,
}: ExpandableDetailsButtonProps) => {
  const [expanded, setExpanded] = useState();

  const handleClick = (event: SyntheticMouseEvent<>) => {
    // If the user is holding a modifier key, or pressed a button other than the
    // left mouse button, let the browser handler it.
    if (event.metaKey || event.ctrlKey || event.button !== 0) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    setExpanded((wasExpanded) => !wasExpanded);
  };

  return (
    <Group>
      <Button
        label={<FormattedMessage {...messages.viewDetails} />}
        icon={expanded ? chevronUp : chevronDown}
        iconPosition="right"
        onClick={handleClick}
      />
      {expanded && children}
    </Group>
  );
};
